var LoggingEventType = {
  APPLICATION: 'APPLICATION',
  AUTHENTICATION: 'AUTHENTICATION',
  AUTHORIZATION: 'AUTHORIZATION',
  PAYMENTS: 'PAYMENTS',
  SUSPICIOUS: 'SUSPICIOUS',
  SESSION: 'SESSION',
  SYSTEM: 'SYSTEM',
  VALIDATION: 'VALIDATION',
  OTHER: 'OTHER'
};
Object.freeze(LoggingEventType);
export default LoggingEventType;